import userOrCompany from 'src/screens/[slug]';
export default userOrCompany;
